import { getAvailableLendersByLenderCommissions } from '__core/shared/util/salestrekker';
import template from './homeLoanFundingWorksheet.template.html';

export default {
  controller: class controller {
    constructor(
      $q,
      $rootScope,
      $timeout,
      $mdUtil,
      $mdMedia,
      $mdDialog,
      eventService,
      authenticationService,
      dateTimeService,
      quickToolService,
      helperService,
      organizationService,
      accountService,
      liabilitiesService,
      homeLoanService,
      lendersService,
      FundingWorksheet,
      Workflow,
      WorkflowType,
      pdfService
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.isAuthenticated = authenticationService.isAuthenticated();
      ctrl.hasBrokerToolsEnabled = false;

      ctrl.initialize = () => {
        ctrl.hasBrokerToolsEnabled = ctrl.isAuthenticated
          ? $rootScope.hasBrokerToolsEnabled()
          : false;

        ctrl.destroyWatch = eventService.onQuickToolHomeLoanFundingWorksheet((params) => {
          $mdDialog
            .show({
              targetEvent: params.event,
              locals: {},
              template,
              controllerAs: '$ctrl',
              controller() {
                const ctr = this;
                ctr.activeSection = 'edit';
                ctr.isReady = false;
                ctr.isDownloadPreparing = false;
                ctr.isEnterprise = $rootScope.IsEnterprise;
                ctr.currentAccount = $rootScope.CurrentAccount;
                ctr.currentOrganization = $rootScope.CurrentOrganization;
                ctr.organizationCountry = helperService.getOrganizationCountry().cca2;
                ctr.hasBrokerToolsEnabled = $rootScope.hasBrokerToolsEnabled();
                ctr.currentTimeZone = $rootScope.CurrentTimeZone();
                ctr.currentLocale = $rootScope.CurrentLocale();
                ctr.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
                ctr.currentCurrency = $rootScope.CurrentCurrency();
                ctr.isDev = $rootScope.isDev();
                ctr.lenders = [];
                ctr.lendersPerCountry = [];
                ctr.documents = [];
                ctr.numberOfApplicants = 0;
                ctr.isSelfEmployment = false;
                ctr.numberOfSecurities = 0;
                ctr.workflow = Workflow.build({
                  type: WorkflowType.of(WorkflowType.home_loan.name)
                });
                ctr.fundingWorksheets = FundingWorksheet.Blank();
                ctr.securities = [];
                ctr.contacts = [];

                ctr.validateRequiredFields = () =>
                  ctr.numberOfApplicants !== '' && ctr.numberOfApplicants > 0;

                $q.all([
                  organizationService.readOrganization({ id: ctr.currentOrganization?.id }),
                  accountService.readAccount({ id: ctr.currentAccount?.id }),
                  lendersService.getAvailable({
                    cca2: [ctr.organizationCountry],
                    type: 'RESIDENTIAL'
                  })
                ]).then((data) => {
                  const organization = data[0];
                  const account = data[1];
                  const lenders = data[2];
                  ctr.isBroker = authenticationService.isBroker(account.id);

                  if (lenders?.length && account?.lenderAccreditations?.length) {
                    ctr.lendersPerCountry = _.chain(lenders)
                      .sortNatural('name')
                      .sortNatural('group')
                      .value();
                    ctr.lenders = getAvailableLendersByLenderCommissions(
                      lenders,
                      organization,
                      account,
                      ctr.workflow,
                      ctr.isEnterprise,
                      false
                    );
                  }
                  ctr.hasHomeLoanTools =
                    ctr.hasBrokerToolsEnabled && ctr.isBroker && ctr.lenders.length;
                  ctr.isReady = true;

                  if (ctr.lenders.length) {
                    const idLenders = _.map(ctr.lenders, 'id');
                    lendersService
                      .getDocuments({ idLenders, types: ['LOGO'] })
                      .then((lendersDocuments) => {
                        if (lendersDocuments && lendersDocuments.length) {
                          ctr.documents = lendersDocuments;
                        }
                      });
                  }

                  ctr.availableApplicants = homeLoanService.getAvailableApplicants();

                  ctr.contact = () => ({
                    id: _.uuid(),
                    idSpouse: '',
                    married: false,
                    dependents: 0,
                    totalIncome: 0
                  });

                  ctr.security = () => ({
                    id: _.uuid(),
                    address: {
                      state: '',
                      countryCode: '',
                      postCode: ''
                    },
                    value: 0
                  });

                  if (!ctr.securities.length) {
                    const security = ctr.security();
                    security.address.countryCode = ctr.organizationCountry;
                    ctr.securities = [security];
                  }

                  ctr.availableSpouses = [
                    { id: 'notInApplication', value: 'Not in application' }
                  ];

                  ctr.toggleApplicants = () => {
                    if (ctr.numberOfApplicants !== '') {
                      let start = 0;
                      let len = 0;
                      let isAdding = false;
                      if (ctr.contacts.length !== ctr.numberOfApplicants) {
                        if (ctr.contacts.length === 0) {
                          start = 0;
                          len = ctr.numberOfApplicants;
                          isAdding = true;
                        } else if (
                          ctr.contacts.length > 0 &&
                          ctr.contacts.length < ctr.numberOfApplicants
                        ) {
                          start = ctr.contacts.length;
                          len = ctr.numberOfApplicants;
                          isAdding = true;
                        } else if (
                          ctr.contacts.length > 0 &&
                          ctr.contacts.length > ctr.numberOfApplicants
                        ) {
                          start = ctr.numberOfApplicants;
                          len = ctr.contacts.length;
                          isAdding = false;
                        }
                        for (let a = start; a < len; a += 1) {
                          if (isAdding) {
                            const contact = ctr.contact();
                            ctr.contacts.push(contact);
                            ctr.availableSpouses.push({
                              id: contact.id,
                              value: `Applicant ${a + 1}`
                            });
                          } else {
                            const { id } = ctr.contacts[a];
                            const idx = helperService.findIndexById(ctr.contacts, id);
                            if (idx > -1) {
                              helperService.removeItemFromArray(ctr.contacts, idx);
                            }
                            const mIdx = helperService.findIndexById(ctr.availableSpouses, id);
                            if (mIdx > -1) {
                              helperService.removeItemFromArray(ctr.availableSpouses, mIdx);
                            }
                          }
                        }
                      }
                    } else {
                      ctr.contacts = [];
                    }
                  };

                  ctr.removeCurrentApplicant = (idApplicant) => (item) => {
                    if (item.id === idApplicant) {
                      return false;
                    }
                    return true;
                  };

                  ctr.filteredSpouses = (sIdx) =>
                    ctr.availableSpouses.filter(
                      (spouse) =>
                        !_.find(ctr.contacts, (contact, idx) => {
                          if (sIdx === idx) {
                            return false;
                          }
                          return contact.idSpouse === spouse.id;
                        })
                    );

                  ctr.toggleSpouse = (contact) => {
                    const sIdx = _.findIndex(ctr.contacts, (c) => c.id === contact.idSpouse);
                    if (sIdx > -1) {
                      ctr.contacts[sIdx].married = true;
                      ctr.contacts[sIdx].idSpouse = contact.id;
                    }
                  };

                  ctr.addSecurity = () => {
                    ctr.isFundingWorksheetReady = false;
                    const security = ctr.security();
                    security.address.countryCode = ctr.organizationCountry;
                    ctr.securities.push(security);
                    $timeout(() => {
                      ctr.isFundingWorksheetReady = true;
                    });
                  };

                  ctr.deleteSecurity = (idSecurity) => {
                    ctr.isFundingWorksheetReady = false;
                    const idx = _.findIndex(ctr.securities, (s) => s.id === idSecurity);
                    if (idx > -1) {
                      ctr.securities.splice(idx, 1);
                      const fRIdx = _.findIndex(
                        ctr.fundingWorksheets?.fundsRequired || [],
                        (f) => f.idSecurity === idSecurity
                      );
                      if (fRIdx > -1) {
                        ctr.fundingWorksheets.fundsRequired.splice(fRIdx, 1);
                      }
                      if (ctr.fundingWorksheets?.fundsAvailable?.length > 1) {
                        const fAIdx = _.findIndex(
                          ctr.fundingWorksheets?.fundsAvailable || [],
                          (f) => f.idSecurity === idSecurity
                        );
                        if (fAIdx > -1) {
                          ctr.fundingWorksheets.fundsAvailable.splice(fAIdx, 1);
                        }
                      }
                    }
                    if (!ctr.securities.length) {
                      ctr.addSecurity();
                    }
                    $timeout(() => {
                      ctr.isFundingWorksheetReady = true;
                    });
                    const editedData = {
                      fundingWorksheets: ctr.fundingWorksheets,
                      hLCD: 'homeLoanFundingWorksheet'
                    };
                    ctr.saveFundingWorksheets(editedData);
                  };

                  ctr.updateFundingWorksheets = (fundingWorksheets) => {
                    if (!_.isEmpty(fundingWorksheets)) {
                      for (let i = 0; i < fundingWorksheets.fundsRequired.length; i += 1) {
                        fundingWorksheets.fundsRequired[i].deleteDateObject();
                      }
                      ctr.fundingWorksheets = fundingWorksheets;
                    }
                  };

                  ctr.saveFundingWorksheets = (editedData) => {
                    ctr.updateFundingWorksheets(editedData?.fundingWorksheets);
                    ctr.saveChanges(editedData);
                  };

                  ctr.saveChanges = (editedData) => {
                    const hLCD = editedData?.hLCD || '';
                    $timeout(() => {
                      eventService.changedData({ changedData: hLCD });
                    }, 1000);
                  };

                  ctr.showSection = (section) => {
                    ctr.activeSection = section;
                    if (ctr.activeSection === 'result') {
                      ctr.isFundingWorksheetReady = true;
                    }
                  };

                  ctr.createPdf = (isView) => {
                    if (isView) {
                      ctr.isViewPreparing = true;
                    } else {
                      ctr.isDownloadPreparing = true;
                    }
                    pdfService
                      .createPdf({
                        fundingWorksheets: ctr.fundingWorksheets,
                        homeLoanSecurities: ctr.securities,
                        pdfType: helperService.getAvailablePdfTypes()[2],
                        isQuickTool: true,
                        isView
                      })
                      .then(() => {
                        if (isView) {
                          ctr.isViewPreparing = false;
                        } else {
                          ctr.isDownloadPreparing = false;
                        }
                      });
                  };
                });
                ctr.cancel = () => {
                  $mdDialog.cancel();
                };
              }
            })
            .then(() => {
              //
            });
        });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
